module.exports = __webpack_public_path__ + "static/idea-8cbff79d862d88bae3bde06672fa9571.svg";